import {
  Button,
  DialogActions,
  DialogContent,
  FilledInput,
  FormControl,
  InputLabel,
  Stack,
  TextField,
} from "@mui/material";
import React from "react";
import CheckboxWithText from "../../../components/Dialog/CheckboxWithText";
import DialogHeader from "../../../components/Dialog/DialogHeader";
import UserDialog from "../../../components/Dialog/UserDialog";
import { Api } from "../../../request/api/api";
import { useFieldChange } from "../../../userHooks/useFieldChange";

interface State {
  name: string;
  cash: number;
  reputation: number;
  description: string;
  isOutlaw: boolean;
}

export interface EditTeamInfoDialogProps {
  teamId: string;
  initState: State;
  fetchData: () => void;
  open: boolean;
  onClose: () => void;
}

export default function EditTeamInfoDialog({
  teamId,
  initState,
  fetchData,
  onClose,
  open,
}: EditTeamInfoDialogProps) {
  const [teamInfo, setTeamInfo] = React.useState<State>(initState);
  const handleChange = useFieldChange(teamInfo, setTeamInfo);
  const [inputError, setInputError] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  const fighterInfoIsCorrect = () => {
    let result = teamInfo.name.length >= 3;
    if (!result) {
      setInputError(true);
    }

    return result;
  };

  const handleAdd = async () => {
    if (fighterInfoIsCorrect()) {
      setLoading(true);
      setError(null);
      const result = await Api.team.editTeam({
        teamId: teamId,
        request: { ...teamInfo },
      });
      setLoading(false);
      if (result.success) {
        onClose();
        fetchData();
      } else {
        setError(result.errorMessage ?? "Ошибка при сохранении");
      }
    }
  };

  const handleClose = () => {
    setError(null);
    onClose();
  };

  return (
    <UserDialog handleClose={handleClose} open={open} error={error}>
      <DialogHeader loading={loading} title="Редактировать данные банды" />
      <DialogContent sx={{ minHeight: "200px" }}>
        <Stack spacing={2}>
          <TextField
            error={inputError}
            value={teamInfo.name}
            onChange={handleChange("name")}
            id="filled-basic-name"
            label="Название"
            variant="filled"
          />
          <FormControl
            sx={{
              m: 1,
            }}
            variant="filled">
            <InputLabel htmlFor="credits">Кредиты</InputLabel>
            <FilledInput
              value={teamInfo.cash}
              type="number"
              onChange={handleChange("cash")}
              id="filled-basic-credits"
            />
          </FormControl>
          <FormControl
            sx={{
              m: 1,
            }}
            variant="filled">
            <InputLabel htmlFor="credits">Репутация</InputLabel>
            <FilledInput
              value={teamInfo.reputation}
              type="number"
              onChange={handleChange("reputation")}
              id="filled-basic-reputation"
            />
          </FormControl>
          <CheckboxWithText
            checked={teamInfo.isOutlaw}
            onChange={() =>
              setTeamInfo({
                ...teamInfo,
                isOutlaw: !teamInfo.isOutlaw,
              })
            }
            loading={loading}
            text="Вне закона"
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Назад</Button>
        <Button onClick={handleAdd}>Сохранить</Button>
      </DialogActions>
    </UserDialog>
  );
}
